export enum E_WebDisplayCellSubtype {
    Mobility = "Mobility",
    Isolation = "Isolation",
    Test = "Tests",
    Therapy = "Therapies",
    Intervention = "Procedures",
    Visits = "Visits",
    Therapeutic = "Therapeutic",
    Altable = "Altable",
    Default = "",

    // GENERLA
    Nurse = "Nurse",
    Smart = "Smart",



    // SMART DISPLAY

    Days = "d",
    WeeksDays = "w+d",
}

export enum E_WebDisplayCellType {
    BeaconColor = "BeaconColor",
    // Alert = "Alert",
    Alarm = "Alarm",
    GraphCompose = "GraphCompose",
    GraphTitle = "GraphTitle",
    Sensors = "Sensors",
    SensorAwair = "SensorAwair",
    SensorObs = "SensorObs",
    SensorWrapper = "SensorWrapper",
    ObsGa = 'ObsGa',
    ObsText = 'TextObs',
    ObsIcon = 'ObsIcon',
    ObsIconText = 'ObsIconText',
    WeightObs = 'WeightObs',
    PlainIconText = 'PlainIconText',
    ObsBoolean = "ObsBoolean",
    ObsMultiIcon = "ObsMultiIcon",
    ObsMultiText = "ObsMultiText",
    LifeTime = "LifeTime",
    ObsIsolation = "ObsIsolation",
    BirthObs = "BirthObs",
    PatientLanguage = "PatientLanguage",
    // COMMON
    Default = "Default",
    AltableDropDown = "AltableDropDown",
    BoxNumber = "BoxNumber",
    RowDivider = "RowDivider",
    CellDivider = "CellDivider",
    Filler = "Filler",
    TagsCell = "TagsCell",
    // NURSE - ITEMS
    FullAccessControl = "FullAccessIcon",
    AccessControl = "AccessIcon",
    FullIcon = "FullIcon",
    List = "List",
    TherapeuticCelling = "TherapeuticCeiling",
    DoctorCell = "DoctorCell",
    DemographicCell = "DemographicCell",
    HumanizationCell = "HumanizationCell",
    VisitIcon = "VisitIcon",
    DropDown = "DropDown",
    LenguageBarrier = "LenguageBarrier",
    DaysCalendarCell = "DaysCalendarCell",
    AllergyCell = "AllergyCell",
    ObsCell = "ObsCell",
    ObsCellIcon = "ObsCellIcon",
    IncomingDate = "IncomingDate",
    UciDays = "UciDays",
    ObsTextIfMatch = "ObsTextIfMatch",
    DynamicText = "DynamicText",
    CellSection = "CellSection",
    ClinicalRouteCell = "ClinicalRouteCell",
    ClinicalRouteList = "ClinicalRouteList",
    CatheterCell = "CatheterCell",
    CatheterList = "CatheterList",

    // NURSE - SECTION
    Admission = "Admission",
    Demographic = "Demographic",
    Isolation = "Isolation",
    DetailHeader = "DetailHeaderSection",
    PatientInfo = "PatientInfo",
    Physicians = "Physicians",
    AltableInfo = "AltableInfo",
    WrapperSection = "WrapperSection",
    WrapperSectionCell = "WrapperSectionCell",
    WrapperCell = "WrapperCell",
    TherapiesSection = "TherapiesSection",
    TestSection = "TestSection",
    InterventionSection = "InterventionSection",
    IncomingSection = "IncomingSection",
    // NURSE - TABLE CONFIG
    TableGender = "TableGender",
    TableText = "TableText",
    TableIcon = "TableIcon",
    TableDropdown = "TableDropdown",
    TableInsulation = "TableInsulation",
    TableButtonEmptyBed = "TableButtonEmptyBed",
    TableBoxRepeated = "TableBoxRepeated",
    TableAge = "TableAge",
    TableBox = "TableBox",
    TableDate = "TableDate",
    TableCell = "TableCell",
    FlexGroup = "FlexGroup",
    PatientStatusIcon = "PatientStatusIcon",
    PatientStatusFullIcon = "PatientStatusFullIcon",
    CarePlanObjective = "CarePlanObjective",
    MultiIconEpis = "MultiIconEpis",
    TextAreaEditable = "TextAreaEditable",
    DestinationIcon = "DestinationIcon",
    AlarmStatusIcon = "AlarmStatusIcon",
    NurseCallIcon = "NurseCallIcon",
}
